import { URLS } from '../../../constants';
import apiClient from '../../client';

const historyGrid = {
  diagnosisCodeHistoryGrid: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.diagnosisCodeHistory, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'executedOn',
        },
        id,
      },
    }),
  insuranceHistoryGrid: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.insuranceHistory, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'executedOn',
        },
        id,
      },
    }),
  servicesHistoryGrid: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.servicesHistory, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'executedOn',
        },
        id,
      },
    }),
  emailHistoryGrid: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.emailFormatHistory, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'executedOn',
        },
        id,
      },
    }),
  sessionDetailsGrid: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.sessionDetailsGrid, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'id',
        },
        id,
      },
    }),
  terminateSessionDetailsGrid: ({
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.terminateSessionsDetails, {
      data: {
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'id',
        },
        sessionId: id,
      },
    }),
};

export default historyGrid;
